import React from "react";
import PropTypes from "prop-types";
import { themeColors } from "../../themeColors";
import { useNavigate } from "react-router-dom";

const BackLinkButton = ({
  shouldToggleColor,
  to,
  role = "link",
  onClick,
  variant = "btn",
  tabIndex = 0,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) return onClick();
    if (to) navigate(to);
  };

  const baseClass = variant === "small" ? "back-link-small" : "back-link-btn";

  return (
    <a
      role={role === "button" ? "button" : undefined}
      className={`${baseClass} ${shouldToggleColor ? "back-link-btn-premium" : ""}`}
      href={void 0}
      onClick={handleClick}
      tabIndex={tabIndex}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
          fill={
            shouldToggleColor ? themeColors.neutral000 : themeColors.neutral890
          }
        />
      </svg>
    </a>
  );
};

BackLinkButton.propTypes = {
  onClick: PropTypes.func,
  shouldToggleColor: PropTypes.bool.isRequired,
  role: PropTypes.oneOf(["link", "button"]),
  to: PropTypes.string,
  tabIndex: PropTypes.number,
};

export default BackLinkButton;
